import { useEffect, useState } from 'react';

/**
 * False until the component has been on screen for a frame. A Sheet mounted
 * the first time it opens passes this as its `canOpen`: one that mounts
 * already open doesn't slide in, and its focus trap runs before its portal
 * exists, so focus never moves into it. Two frames: the first commits the
 * closed sheet, the second opens it after the browser has styled it closed.
 */
export function useHasPainted() {
   const [hasPainted, setHasPainted] = useState(false);

   useEffect(() => {
      let second = 0;
      const first = requestAnimationFrame(() => {
         second = requestAnimationFrame(() => setHasPainted(true));
      });
      return () => {
         cancelAnimationFrame(first);
         cancelAnimationFrame(second);
      };
   }, []);

   return hasPainted;
}
